import { Sorting, SortingParam } from 'src/common/components/Filters/constants/sorting';

export const createSortingParamsValidator =
  ({
    allowedColumnNames,
    allowedDirection,
  }: {
    allowedColumnNames: Set<string>;
    allowedDirection: Set<Sorting>;
  }) =>
  ({ sorting }: { sorting: SortingParam }) => {
    return (
      !!sorting && allowedColumnNames.has(sorting.columnName) && allowedDirection.has(sorting.sort)
    );
  };

export const createSortingParamsSetter = ({
  allowedColumnNames,
  allowedDirection,
}: {
  allowedColumnNames: Set<string>;
  allowedDirection: Set<Sorting>;
}) => {
  const checkIfParamsValid = createSortingParamsValidator({
    allowedColumnNames,
    allowedDirection,
  });
  return ({ searchParams, sorting }: { searchParams: URLSearchParams; sorting: SortingParam }) => {
    const sortingParamsValid = checkIfParamsValid({ sorting });
    if (sortingParamsValid) {
      searchParams.set('columnName', sorting!.columnName);
      searchParams.set('sort', sorting!.sort!);
    }
  };
};
